<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" class="bottom-tabbar">
        <ion-tab-button tab="tab0" href="/StudentIndex" @click="changeBtn(1)">
          <!-- <ion-icon :icon="homeOutline"/> -->
          <img v-show="!isOne" class="pic" :src="getBrandImageUrl('tabbar/stu_home.png')" alt="" />
          <img
            v-show="isOne"
            class="pic"
            :src="getBrandImageUrl('tabbar/stu_home_active.png')"
            alt=""
          />

          <ion-label class="label" :class="{ active: isOne }">首页</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab1" href="/PersonalClassRecord" @click="changeBtn(2)">
          <!-- <ion-icon :icon="timerOutline"/> -->
          <img
            v-show="!isTwo"
            class="pic"
            :src="getBrandImageUrl('tabbar/record_icon.png')"
            alt=""
          />
          <img
            v-show="isTwo"
            class="pic"
            :src="getBrandImageUrl('tabbar/record_active_icon.png')"
            alt=""
          />
          <ion-label class="label" :class="{ active: isTwo }">训练记录</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab2" href="/StudentRanking" @click="changeBtn(3)">
          <!-- <ion-icon :icon="listOutline"/> -->
          <img
            v-show="!isThree"
            class="pic"
            :src="getBrandImageUrl('tabbar/stu_rank.png')"
            alt=""
          />
          <img
            v-show="isThree"
            class="pic"
            :src="getBrandImageUrl('tabbar/stu_rank_active.png')"
            alt=""
          />
          <ion-label class="label" :class="{ active: isThree }">排行榜</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab4" href="/StudentPersonalIndex" @click="changeBtn(4)">
          <!-- <ion-icon :icon="personOutline"/> -->
          <img v-show="!isFour" class="pic" :src="getBrandImageUrl('tabbar/stu_mine.png')" alt="" />
          <img
            v-show="isFour"
            class="pic"
            :src="getBrandImageUrl('tabbar/stu_mine_active.png')"
            alt=""
          />
          <ion-label class="label" :class="{ active: isFour }">个人中心</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonPage, IonRouterOutlet } from "@ionic/vue"
import {
  timerOutline,
  libraryOutline,
  personOutline,
  listOutline,
  homeOutline,
} from "ionicons/icons"
import { getBrandImageUrl } from "@/js/brandImages"

export default {
  name: "StudentTabs",
  components: {
    IonLabel,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonPage,
    IonRouterOutlet,
  },
  setup() {
    return {
      timerOutline,
      libraryOutline,
      personOutline,
      homeOutline,
      listOutline,
    }
  },

  data() {
    return {
      isOne: false,
      isTwo: false,
      isThree: false,
      isFour: false,
    }
  },
  mounted() {
    console.log("mounted", this.$route)
    if (this.$route.path == "/StudentIndex") {
      this.isOne = true
    }
    if (this.$route.path == "/PersonalClassRecord") {
      this.isTwo = true
    }
    if (this.$route.path == "/StudentRanking") {
      this.isThree = true
    }
    if (this.$route.path == "/StudentPersonalIndex") {
      this.isFour = true
    }
  },
  methods: {
    getBrandImageUrl,
    changeBtn(type) {
      if (type == 1) {
        if (this.isOne) {
          return
        }
        this.isOne = !this.isOne
        this.isTwo = false
        this.isThree = false
        this.isFour = false
      }
      if (type == 2) {
        if (this.isTwo) {
          return
        }
        this.isTwo = !this.isTwo
        this.isOne = false
        this.isThree = false
        this.isFour = false
      }
      if (type == 3) {
        if (this.isThree) {
          return
        }
        this.isThree = !this.isThree
        this.isTwo = false
        this.isOne = false
        this.isFour = false
      }
      if (type == 4) {
        if (this.isFour) {
          return
        }
        this.isFour = !this.isFour
        this.isThree = false
        this.isTwo = false
        this.isOne = false
      }
    },
  },
}
</script>
<style scoped>
.bottom-tabbar {
  height: 15vmin;
  display: flex;
  justify-content: space-around;
}

.pic {
  width: 6vmin;
  margin-bottom: 0.125rem;
}
.label {
  color: #868f9e;
}
.active {
  color: #262626;
}

@media screen and (min-width: 600px) {
  .label {
    font-size: 3vmin;
  }
}
</style>
